import { MappedClass, MappedProperty } from '@h5s/util-object';

@MappedClass()
export class CashRegisterInvoiceHolder {
  @MappedProperty()
  fiscalCode: string | null;

  @MappedProperty()
  lines: string[];

  @MappedProperty()
  lotteryCode: string | null;
}
